import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import SweetAlert from 'react-bootstrap-sweetalert'
import UserRolesTable from '../Users/UserRolesTable.';
import UserProfileCard from '../Users/UserProfileCard';
import IntlMessages from 'util/IntlMessages';
import {history} from '../../../store';

import { getUserRolesFullByUserIdApi, deleteUserRolesApi, getRolesAllApi, postUserRolesApi, getSAYSProjectApi, getRolesCustomDetailApi } from '../../../api/userRoles';
import {connect} from 'react-redux';
import config from '../../../config';
import { CircularProgress } from '@material-ui/core';
class ShowUserRolesDialog extends React.Component {
  state = {
    open: false,
    success : false,
    error:false,
    errorMessage:'',
    successMessage:'',
    updateWarning :false,
    userRoleList:[],
    user:{},
    roles:[],
    selectedRoleId : 0,
    selectedRole:{      
        appId:0,
        customSelect:0,
        id:0,
        instSelect:0,
        name:"",
        label:"Detay "
    },
    selectedInst: "",
    journalList : config.journals.filter(x=>x.inst=== "ATAM"),
    selectedCustom:0,
    saysProjects:[] ,

    customLabel : "",
    customData:[],
    customData2:[],
    loading:false,
  };


  componentDidMount = async() =>{
    const roles = await getRolesAllApi();
    const result =  await getUserRolesFullByUserIdApi(this.props.user.id);

    roles.push(
      {
        id:0,
        name : "Seçiniz (Select)"
      }
        );
        this.setState({loading:true});

        let customData = [] ;
        customData = await getRolesCustomDetailApi();
        
        customData.push(
               {
                 id:0,
                 customId:0,
                 name : "Seçiniz (Select)"
               }
           );


    this.setState({
      user : this.props.user,
      roles,
      customData,
      customData2:customData,
      userRoleList:result.userRoles.map(x=>{ 
        if(x.customId>0)
          x.customDetail = customData.find(y=>y.customId === x.customId && y.roleId === x.roleId)

          return x;
       }),

      
       loading:false,
    });
  }

  componentWillReceiveProps= async(nextProps)=>{
    ////console.log("gelen user", nextProps.user)
   // const userRoleList =  nextProps.user.userRoles;
   this.setState({loading:true});

    const result =  await getUserRolesFullByUserIdApi(nextProps.user.id);

    if(result.status){
      this.setState({
        userRoleList:result.userRoles.map(x=>{ 
          if(x.customId>0)
            x.customDetail = this.state.customData.find(y=>y.customId === x.customId && y.roleId === x.roleId)

          return x;
         }),
        open: true ,
        user : nextProps.user,
        loading:false,

      });
    }
    else
    {
      if(result.error.status === 403)
      history.push("/bbs/error403");
      else
      history.push("/bbs/error404");
    }
////console.log("son seçilen : ",nextProps.user )
   
  }
  


  onClickDeleteUserRole = async(userRoleId)=>{
  //  //console.log("object ",userRoleId);
    let userRoleList1 = this.state.userRoleList;
    userRoleList1 = userRoleList1.filter(x=> x.id !== userRoleId);
    const result = await deleteUserRolesApi(userRoleId);

  
    if(result.status){
      this.setState({
        userRoleList:userRoleList1
      });
    }
 
  }

  handleChange = (name) => event => {
      this.setState({
      selectedRoleId: Number(event.target.value),
    });

};
handleChangeInst = (event) => {
  const { saysProjects} = this.state;

  const customData = this.state.customData2.filter(x=>( x.roleId === this.state.selectedRoleId &&  x.inst === event.target.value));
console.log('customData ', customData )
  this.setState({
  selectedInst: event.target.value,
  customData ,
  selectedCustom : customData.length >= 1 ? Number(customData[0].customId) : this.state.selectedCustom
  //selectedCustom : config.journals.filter(x=>x.inst===event.target.value),
  //selectedCustom :  (this.state.selectedRoleId>200 && this.state.selectedRoleId<204) && saysProjects.filter(x=>x.inst===event.target.value).length > 0 ? saysProjects.filter(x=>x.inst===event.target.value)[0].id : 0 ,
});

};

handleChangeCustom = (event) => {
  console.log('Number(event.target.value) ', Number(event.target.value) )
  this.setState({
  selectedCustom:Number(event.target.value),

});
 
};

onClickSaveUserRole = async()=>{
  if(this.state.selectedRoleId===0)
  {
    this.setState({
      error:true,
      errorMessage:<IntlMessages id="user.roles.notselect"/>,
  
    });
  }
  else if( this.state.selectedRole.instSelect === 1 && this.state.selectedInst ==="")
  {
    this.setState({
      error:true,
      errorMessage:"Kurum seçimi yapmak zorunludur.",
  
    });
  }
  else if( this.state.selectedRole.customSelect === 1 && this.state.selectedCustom ===0 )
  {
    this.setState({
      error:true,
      errorMessage: this.state.selectedRole.customLabel +  " Seçimi zorunludur.",
  
    });
  }
 
  else
  {
     
            const userRole = {
               roleId:this.state.selectedRoleId,
                userId:this.state.user.id,
               inst: this.state.selectedInst,
               customId:this.state.selectedCustom,
               addedUserId:this.props.authUser.id,
                };

                console.log('userRole ', userRole )

            const result = await postUserRolesApi(userRole);
            if(result.status){
              userRole.id = result.id;
              let userRoleList1 = this.state.userRoleList;
              userRole.name = this.state.roles.filter(x=> x.id === userRole.roleId)[0].name  ;
              userRole.customDetail = this.state.customData.find(y=>y.customId === userRole.customId && y.roleId === userRole.roleId)
              userRoleList1.push(userRole);
          
          
              this.setState({
                success:true,
                successMessage:'Rol başarıyla eklendi',
                userRoleList:userRoleList1,
                selectedCustom:0 ,
                inst:""
              });
          
            }
            else{
              this.setState({
                error:true,
                errorMessage:'Hata Oluştu',
            
              });
            }
      

}
}

onChangeSelectedRole = async (e)=>{
  const selectedRole = this.state.roles.find(a=>a.id === Number(e.target.value)) ;
if(selectedRole.customSelect===1)
{
  let customData,customLabel;
  customData =  this.state.customData2.filter(x=>x.roleId === selectedRole.id) ;
  customLabel = selectedRole.customLabel;

  this.setState({ 
    customLabel,
    customData,
    selectedRoleId: Number(e.target.value) , 
    selectedRole 
  })

}
else{
  this.setState({ 
    selectedRoleId: Number(e.target.value) , 
     selectedRole 
   })
 
}


}

  render() {
    const { success , error, userRoleList,selectedRoleId,selectedInst ,selectedCustom,selectedRole , customData,customLabel} = this.state;
  //  //console.log("adasda",asdad);
    return (
      <div>

        <Dialog open={this.props.open} onClose={this.props.onModalClose} fullWidth maxWidth="lg">
          <DialogTitle style={{backgroundColor:"#f4f4f7"}}><IntlMessages id="profile.userRoles"/></DialogTitle>
          <DialogContent style={{backgroundColor:"#f4f4f7"}}>
          <div className="row">
          <div className="col-lg-3 col-md-6 col-sm-5 col-12">
              <UserProfileCard headerStyle="bg-secondary" user={this.state.user}/>
            </div>
            <div className="col-lg-9 col-md-6 col-sm-7 col-12">

{ this.state.loading ? <CircularProgress /> :
            <UserRolesTable userRoleList={userRoleList} onClickDeleteUserRole={this.onClickDeleteUserRole}/>
           }
           <div className="row">
       
           <div className="col-md-5 col-12">
                  <TextField
                    id="roleId"
                    select
                    required
                    label={ <IntlMessages id="user.roles.selectRole"/>}
                    value={selectedRoleId}
                    onChange={this.onChangeSelectedRole}
                    SelectProps={{
                      native: true
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    margin="normal" 
                    fullWidth
                  >
                   
                    {this.state.roles.map(option => (
                      <option key={option.id} value={option.id}>
                        {option.name}
                      </option>
                    ))}
                  </TextField>
              
           </div>

           <div className="col-md-3 col-12">
             { 
                (selectedRole.instSelect === 1 ) &&
             
                  <TextField
                    id="inst"
                    select
                    required
                    label={ <IntlMessages id="about.institutions"/>}
                    value={selectedInst}
                    onChange={this.handleChangeInst}
                    SelectProps={{
                      native: true
                    }}
                    margin="normal"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                  >
                     <option value={""}>
                        Seçiniz
                      </option>
                      <option value={"YK"}>
                        YK
                      </option>
                      <option value={"ATAM"}>
                        ATAM
                      </option>                 
                      <option value={"AKM"}>
                        AKM
                      </option>
                      <option value={"TTK"}>
                        TTK
                      </option>
                      <option value={"TDK"}>
                        TDK
                      </option>
                  </TextField>
  }
           </div>

           <div className="col-md-2 col-12">

           { 
                (selectedRole.customSelect === 1 ) &&
             
                  <TextField
                    id="customId"
                    select
                    required
                    label={ customLabel}
                    value={selectedCustom}
                    onChange={this.handleChangeCustom}
                    SelectProps={{
                      native: true
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    margin="normal"
                    fullWidth
                  >
                    
                    
                   {  
                     customData.map(j=>
                      <option value={j.customId} key={j.name + j.id}>
                      {j.name}
                    </option>
                      )
                   }
                                   
                 
                 
                  </TextField>
  }

           </div>


           <div className="col-md-2 col-12">
               <Button  margin="normal" variant="contained" color="secondary" className="mt-4 jr-btn text-white" onClick={this.onClickSaveUserRole}> <IntlMessages id="button.add"/></Button>
           </div>
           </div>
       

            </div>
          

          </div>

           
           
          </DialogContent>
          <DialogActions style={{backgroundColor:"#f4f4f7"}}>
            <Button onClick={this.props.onModalClose} color="secondary">
            <IntlMessages id="button.close"/>
            </Button>
            {/* <Button onClick={this.handleRequestUpdate} color="primary">
              Güncelle
            </Button> */}

            <SweetAlert show={success} success title={this.state.successMessage} confirmBtnText={<IntlMessages id="button.ok"/>}
                    onConfirm={()=>{
                      this.setState({success: false});  
                      this.setState({open: false});
                    }
                      }>
                     
             </SweetAlert>
             <SweetAlert show={error} error title={this.state.errorMessage}  confirmBtnText={<IntlMessages id="button.ok"/>}
                    onConfirm={()=>{
                      this.setState({error: false});  
                      this.setState({open: false});
                    }
                      }>
                     
             </SweetAlert>
           



          </DialogActions>
        </Dialog>
     
      
      </div>
    );
  }
}

//export default SaveTalePage;
const mapStateToProps = ({auth}) => {
  const {authUser} = auth;
  return { authUser };
};

export default connect(mapStateToProps)(ShowUserRolesDialog);